import { __assign } from 'tslib';
import React__default from 'react';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

var FrontEditPreview = function (_a) {
    var className = _a.className, _b = _a.testId, testId = _b === void 0 ? "FrontEditPreview" : _b, children = _a.children, sx = _a.sx;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(Box, { className: clsx("FrontEditPreview", className), "data-testid": testId, sx: __assign(__assign({}, sx), { backgroundColor: "grey.200", padding: 4, paddingTop: 1 }) },
        React__default.createElement(Box, { sx: { fontWeight: "bold", paddingBottom: 1 } },
            t("components-front-edit.preview.title.label"),
            React__default.createElement(Typography, { sx: { fontSize: "15px" } }, t("components-front-edit.preview.description.label"))),
        React__default.createElement(Box, { sx: {
                border: function (theme) { return "1px solid ".concat(theme.palette.text.primary); },
                zoom: "90%"
            } }, children)));
};

export { FrontEditPreview as default };
//# sourceMappingURL=index.js.map
